/**
 * SavedStationsContext
 * 
 * 管理已儲存車站的 Context
 */

import React, { createContext, useContext } from 'react';
import { useSavedStations } from '../hooks/useSavedStations';

const SavedStationsContext = createContext(null);

export const SavedStationsProvider = ({ children }) => {
  const savedStations = useSavedStations();

  return (
    <SavedStationsContext.Provider value={savedStations}>
      {children}
    </SavedStationsContext.Provider>
  );
};

export const useSavedStationsContext = () => {
  const context = useContext(SavedStationsContext);
  if (!context) {
    throw new Error('useSavedStationsContext must be used within SavedStationsProvider');
  }
  return context;
};

